/**
 * answer
 */

import request from '../utils/request'

const run = async (data) => {
  const res = await request.httpPost('/qceit/run/run', data)
  return res
}

const stop = async (data) => {
  const res = await request.httpPost('/qceit/run/stop', data)
  return res
}

const output = (data) => {
  return request.httpGet('/qceit/run/output', data)
}

const input = (data) => {
  return request.httpPost('/qceit/run/input', data)
}



export default {
  run,
  stop,
  output,
  input,
}
